import { SocketActions } from '@store/socketSaga'
import * as ActionTypes from '@storeOld/actions'
import { call, put } from 'redux-saga/effects'

import API from '@/api'
import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import type { CommentsActions } from '../actions'

export function* deleteComment({
  payload: { id },
}: ReturnType<typeof CommentsActions.delete>) {
  yield call(API.Comments.delete, id)

  const reducerAction = {
    type: ActionTypes.DELETE_COMMENT,
    payload: { id },
  }

  sendGtmEvent(GtmTriggerName.DELETE_COMMENT)
  yield put(reducerAction)

  yield put(
    SocketActions.emit({
      eventName: 'comments',
      payload: reducerAction,
    })
  )
}
